import * as React from 'react';
import { PurchaseWallpaperItem } from 'types';
import {
  Button,
  Table,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableCell,
  TableBody,
} from 'arbina-ui';
import { ItemEditor } from './components/ItemEditor';
import * as style from './style.sass';

interface Properties {
  items: PurchaseWallpaperItem[];
  onItemsChanged: (items: PurchaseWallpaperItem[]) => any;
}

interface State {
  item: PurchaseWallpaperItem | null;
}

export class Items extends React.Component<Properties> {
  state: State = {
    item: null,
  };

  startAddItem = () => this.setState({
    item: {
      order: this.props.items.length,
      fileToUpload: null,
      width: 0,
      height: 0,
    },
  })

  startEditItem = (item: PurchaseWallpaperItem) => this.setState({ item });

  closeAddItemDialog = () => this.setState({ item: null });

  onItemSubmitted = (item: PurchaseWallpaperItem) => {
    const { items, onItemsChanged } = this.props;
    const index = items.findIndex(i => i.id.toString() === item.id.toString());
    this.setState({ item: null });

    if (index === -1) {
      onItemsChanged(items.concat({
        ...item,
        order: items.length,
      }));
    } else {
      const copy = [...items];
      copy[index] = { ...item };
      onItemsChanged(copy);
    }
  }

  onDeleteItem = (item: PurchaseWallpaperItem) => {
    const { items, onItemsChanged } = this.props;
    const copy = [...items];
    const index = items.findIndex(i => i.id.toString() === item.id.toString());

    if (index !== -1) {
      // Delete item.
      copy.splice(index, 1);

      // Shift indices after deleted item and call handler.
      onItemsChanged(copy.map((i) => {
        return i.order < item.order ? i : { ...i, order: i.order - 1 };
      }));
    }
  }

  onChangeItemOrder = (item: PurchaseWallpaperItem, direction: 'up' | 'down') => {
    const { items, onItemsChanged } = this.props;
    const copy = [...items];
    const temp = { ...item };

    if (direction === 'up') {
      copy[item.order] = {
        ...copy[item.order - 1],
        order: temp.order,
      };

      temp.order -= 1;

      copy[item.order - 1] = temp;
    } else {
      copy[item.order] = {
        ...copy[item.order + 1],
        order: temp.order,
      };

      temp.order += 1;

      copy[item.order + 1] = temp;
    }

    onItemsChanged(copy);
  }

  render() {
    const { items } = this.props;
    const { item } = this.state;

    return (<div>
      <Button
        autoFocus
        secondary
        text="Add item"
        onClick={this.startAddItem}
      />
      {!!item && <ItemEditor
        item={item}
        onClose={this.closeAddItemDialog}
        onSubmit={this.onItemSubmitted}
      />}
      <Table className={style.itemsList}>
        <TableHeader>
          <TableRow>
            <TableHeaderCell>🖼</TableHeaderCell>
            <TableHeaderCell>Size</TableHeaderCell>
            <TableHeaderCell>Order</TableHeaderCell>
            <TableHeaderCell>🔨</TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          <>
            {!items.length ? <TableRow>
              <TableCell
                colSpan={4}
                className={style.empty}
              >
                There is no items in pack.
              </TableCell>
            </TableRow> : null}
            {items.map(item => (<TableRow key={item.id}>
              <TableCell className={style.preview}>
                <img
                  src={item.fileToUpload ?
                    window.URL.createObjectURL(item.fileToUpload) : item.imageUrl}
                />
              </TableCell>
              <TableCell>{item.width} * {item.height}</TableCell>
              <TableCell>{item.order}</TableCell>
              <TableCell className={style.tools}>
                <div>
                  <a onClick={this.startEditItem.bind(this, item)}>⚙</a>
                  <a onClick={this.onDeleteItem.bind(this, item)}>🗑</a>
                  <div className={style.arrows}>
                    {item.order > 0 ?
                      <a
                        className={style.up}
                        onClick={this.onChangeItemOrder.bind(this, item, 'up')}
                      >⬆️</a> :
                      null}
                    {item.order < items.length - 1 ? <a
                        className={style.down}
                        onClick={this.onChangeItemOrder.bind(this, item, 'down')}
                      >⬇️</a> :
                      null}
                  </div>
                </div>
              </TableCell>
            </TableRow>))}
          </>
        </TableBody>
      </Table>
    </div>);
  }
}
